import React, { FunctionComponent, type JSX } from 'react';

import useGetMe from '@/api/queries/me/useGetMe';
import { useTranslation } from '@/i18n';
import { Helmet } from 'react-helmet';
import { Redirect, useParams } from 'react-router';
import AuthenticatedPageWrapper from '../pageWrappers/authenticatedPageWrapper/AuthenticatedPageWrapper';
import './EmbeddableAnalyticsDashboardPage.sass';

export const EmbeddableAnalyticsDashboardPage: FunctionComponent =
  (): JSX.Element => {
    const { analytics, isLoading } = useGetMe();
    const translate = useTranslation();

    const { identifier } = useParams<{ identifier: string }>();

    const embeddableDashboard = analytics?.embeddableDashboards.find(
      (x) => x.uniqueIdentifier === identifier
    );

    const ref = React.useRef<HTMLIFrameElement>(null);

    if (!embeddableDashboard && !isLoading) {
      return <Redirect to="/analytics" />;
    }

    return (
      <>
        <Helmet
          title={`${translate(
            'pages.analytics.title'
          )} - ${embeddableDashboard?.title}`}
        />
        <AuthenticatedPageWrapper className="analytics-embed">
          <div className="typography:prose">
            <h1 className="px-8 py-4">{`Analytics: ${embeddableDashboard?.title || ''}`}</h1>
          </div>
          {embeddableDashboard && (
            <iframe
              ref={ref}
              className="w-full h-full m-0 p-0"
              src={embeddableDashboard?.embedUrl || ''}
              key={embeddableDashboard?.embedUrl}
            ></iframe>
          )}
        </AuthenticatedPageWrapper>
      </>
    );
  };
